var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcRwz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.97949V20.0009C22 20.5528 21.5529 21.0004 21.001 21.0009L3.00102 21.0193C2.44834 21.0199 2 20.572 2 20.0193V4.9999L22 4.97949Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.97949V4.9999M2 4.9999V20.0193C2 20.572 2.44834 21.0199 3.00102 21.0193L21.001 21.0009C21.5529 21.0004 22 20.5528 22 20.0009V4.97949L2 4.9999Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H19.5858C19.851 3 20.1054 3.10536 20.2929 3.29289L21.7071 4.70711C21.8946 4.89464 22 5.149 22 5.41421V16H20V11H13L12 10L11 11H4V16H2V5.41421C2 5.149 2.10536 4.89464 2.29289 4.70711L3.70711 3.29289C3.89464 3.10536 4.149 3 4.41421 3H12Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L19.5858 3C19.851 3 20.1054 3.10536 20.2929 3.29289L21.7071 4.70711C21.8946 4.89464 22 5.149 22 5.41421V16H20V11H13L12 10M12 3H4.41421C4.149 3 3.89464 3.10536 3.70711 3.29289L2.29289 4.70711C2.10536 4.89464 2 5.149 2 5.41421V16H4V11H11L12 10M12 3V10",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcRwz);
export default __webpack_public_path__ + "static/media/jc_rwz.6eb6c95bf9c083d024939c4af0e41ee1.svg";
export { ForwardRef as ReactComponent };